import React from "react"

const OrganisationDocumentsContext = React.createContext({})

const { Provider, Consumer } = OrganisationDocumentsContext

export { Provider, Consumer, OrganisationDocumentsContext }
